class IconNumberTile
    constructor: (el) ->
        @.$el = el
        @.$numberEl = @.$el.querySelector('.icon-number-tile__number')

        @.animate = @.$el.classList.contains 'icon-number-tile--animate'
        @.animated = false
        if @.animate
            @.actualNumber = 0
            @.animationDelay = 50
            @.animationIncrement = if @.$el.dataset?.increment then parseFloat(@.$el.dataset.increment) else 1
            @.animationInterval = undefined
            @.observer = undefined
        @.number = parseFloat @.$numberEl.childNodes[0].textContent
        @.thousandsSeparator = @.$el.dataset?.tSep ? false
        @.unit = @.$el.querySelector('.icon-number-tile__number span')?.textContent ? false

        if @.animate && !@.animated
            @.SetNumber 0
            @.BindObserver()
        else if @.thousandsSeparator
            @.SetNumber @.number
        @.$el.classList.add 'icon-number-tile--bound'
        return

    Animate: ->
        self = @
        if @.animate && !@.animated
            @.animated = true
            window.clearInterval @.animationInterval
            @.animationInterval = window.setInterval ->
                if self.actualNumber == self.number
                    window.clearInterval self.animationInterval
                self.actualNumber += self.animationIncrement
                self.actualNumber = if self.actualNumber > self.number then self.number else self.actualNumber
                self.SetNumber self.actualNumber
                return
            , @.animationDelay
    
    BindObserver: ->
        self = @
        @.observer = new window.IntersectionObserver ([entry]) ->
            if entry.isIntersecting
                self.Animate()
                self.observer.disconnect()
                self.observer = undefined
            return
        , {
            root: null,
            threshold: [0.5]
        }
        @.observer.observe @.$el
        return

    SetNumber: (number) ->
        @.$numberEl.innerHTML = "
            #{ if @.thousandsSeparator then number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, @.thousandsSeparator) else number }#{ if @.unit then "<span>#{ @.unit }</span>" else "" }
        "
        return

BindIconNumberTiles = ->
    document.querySelectorAll '.icon-number-tile:not(.icon-number-tile--bound)'
        .forEach (el) ->
            new IconNumberTile el
            return
    return

window.addEventListener 'bind-components', BindIconNumberTiles